// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/range.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/weight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Images/time.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Images/altitude.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Images/speed.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Images/payload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../Images/lunch.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../Images/landing.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Awfive_aw-container__abUdh {
  width: 100%;
  height: 100vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("https://i.imgur.com/Ye0U6ix.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}

/* Գլխավոր դիվը էկրանով ամբողջությամբ */
.Awfive_aw-section-one__vLn7P {
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 40px 60px;
}

/* Ձախ ներքևի տեքստ */
.Awfive_aw-container__abUdh h3 {
  font-size: 80px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  color: rgba(255, 255, 255, 0.5019607843);
  opacity: 0.5;
  margin-top: 550px;
}

/* Աջ կողմի նկարը */
.Awfive_aw-image__rBQH6 {
  width: 1800px;
  height: 750px;
  background-image: url("https://i.imgur.com/UikQhYH.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.Awfive_sections__Qv2X7 {
  width: 100%;
  max-width: 1500px;
  margin: auto;
  margin-top: -180px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.Awfive_sections-child__NRSYq {
  width: 324px;
  height: 225px;
  background-color: white;
  box-shadow: 1px 1px 1px;
  border-bottom: 1px solid;
  border-right: 1px solid;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 40px;
  transform: perspective(1px) translateZ(0);
  box-shadow: 2px 2px 2px transparent;
  transition-duration: 0.3s;
  transition-property: box-shadow, transform;
}

.Awfive_child-img__c7yna {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awfive_sections-child__NRSYq h2 {
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  color: #4C6D59;
  text-align: center;
}

.Awfive_sections-child__NRSYq p {
  color: #4C6D59;
  font-weight: 500;
  font-size: 25.5px;
  line-height: 100%;
}

.Awfive_weight-img__wNwsw {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awfive_time-img__VkUnM {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awfive_altitude-img__nwsrg {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awfive_speed-img__Uyirm {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awfive_payload-img__BkJIx {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awfive_lunch-img__hD2bS {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awfive_landing-img__u1RlJ {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Awfive_p-Container__wYw8r {
  width: 80%;
}

.Awfive_p-Container__wYw8r p {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Awfive_paragraph-section__zI3e7 {
  width: 80%;
  background-color: #4C6D59;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 150px;
}

.Awfive_paragraph-big__GAzdx {
  width: 100%;
  margin: auto;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 48px;
  position: relative;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
}

.Awfive_paragraph-big__GAzdx p {
  color: white;
  font-size: 32px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  width: 65%;
  line-height: 1.4;
}

.Awfive_paragraph-small-container__DaRQl {
  display: flex;
  height: 60%;
  margin-top: 200px;
  flex-direction: column;
  justify-content: space-between;
  margin-left: -70px;
  z-index: 99;
}

.Awfive_paragraph-small__1AM2K {
  width: 149px;
  height: 94px;
  border: 2px solid white;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: white;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
}

.Awfive_product-section__2CvqI {
  width: 80%;
  height: 113px;
  display: flex;
  margin: auto;
  background-color: #252626;
  margin-bottom: 100px;
  justify-content: space-around;
  align-items: center;
}

.Awfive_product-section__2CvqI span {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Awfive_product-section__2CvqI button {
  width: 300px;
  height: 66px;
  border-radius: 32px;
  border: solid white;
  background-color: #252626;
  color: white;
  font-size: 32px;
  font-weight: 700;
  cursor: pointer;
}

.Awfive_product-section__2CvqI button:hover {
  background-color: white;
  color: #191A1A;
}

.Awfive_threejs-figure__FDFkq {
  width: 80%; /* Adjust to 80% of the container width */
  height: 50vh; /* Adjust height to 50% of viewport height */
  margin: auto; /* Center the container */
  background-color: #333; /* Dark gray background color */
  overflow: hidden; /* Prevent horizontal scrolling */
  display: block; /* Ensure it's a block element */
}

@media (max-width: 1000px) {
  .Awfive_product-section__2CvqI {
    margin-top: -340px;
  }
  .Awfive_product-section__2CvqI span {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .Awfive_product-section__2CvqI button {
    font-size: 16px;
    height: 32px;
    width: 100px;
  }
}
@media screen and (max-width: 1024px) {
  .Awfive_paragraph-big__GAzdx {
    flex-direction: column;
    padding: 30px;
  }
  .Awfive_paragraph-section__zI3e7 {
    max-width: 500px;
    width: 80%;
  }
  .Awfive_paragraph-big__GAzdx {
    margin-left: -2px;
  }
  .Awfive_sections-child__NRSYq {
    width: 280px;
    height: 250px;
  }
  .Awfive_paragraph-big__GAzdx p {
    width: 100%;
    font-size: 24px;
    margin-bottom: 30px;
    text-align: center;
  }
  .Awfive_paragraph-section__zI3e7 {
    height: 500px;
  }
  .Awfive_p-Container__wYw8r p {
    color: white;
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    font-family: "Roboto", sans-serif;
  }
  .Awfive_p-Container__wYw8r h2 {
    font-size: 20px;
  }
  .Awfive_p-Container__wYw8r p {
    font-size: 14px;
  }
  .Awfive_aw-section-one__vLn7P h3 {
    margin-top: 360px;
  }
  .Awfive_aw-container__abUdh {
    height: 800px;
  }
  .Awfive_sections-child__NRSYq {
    margin: auto;
    margin-bottom: 25px;
  }
  .Awfive_product-section__2CvqI {
    margin-top: -500px;
    height: 100px;
  }
  .Awfive_product-section__2CvqI span {
    margin-top: 22px;
  }
  .Awfive_aw-image__rBQH6 {
    width: 400px;
    height: 200px;
    background-size: cover;
    margin-left: -110px;
    margin-top: -40px;
  }
  .Awfive_paragraph-small__1AM2K {
    width: 130px;
    height: 70px;
    font-size: 14px;
    margin-left: 30px;
  }
}
@media screen and (max-width: 600px) {
  .Awfive_sections-child__NRSYq {
    width: 150px;
    height: 150px;
  }
  .Awfive_sections-child__NRSYq h2 {
    font-size: 17px;
    margin-top: 2.5px;
  }
  .Awfive_sections-child__NRSYq p {
    font-size: 14px;
  }
  .Awfive_paragraph-section__zI3e7 {
    margin-top: 200px;
  }
  .Awfive_aw-section-one__vLn7P h3 {
    margin-top: 180px;
    font-size: 19px;
  }
  .Awfive_aw-container__abUdh {
    height: 60vh;
  }
  .Awfive_paragraph-big__GAzdx p {
    font-size: 16px;
  }
  .Awfive_paragraph-small__1AM2K {
    width: 110px;
    height: 60px;
    font-size: 12px;
    margin-left: 30px;
  }
  .Awfive_paragraph-small-container__DaRQl {
    flex-direction: column;
    gap: 16px;
    height: 300px;
  }
  .Awfive_sections-child__NRSYq {
    width: 145px;
    height: 140px;
  }
  .Awfive_child-img__c7yna {
    width: 50px;
    height: 50px;
  }
  .Awfive_weight-img__wNwsw {
    width: 50px;
    height: 50px;
  }
  .Awfive_time-img__VkUnM {
    width: 50px;
    height: 50px;
  }
  .Awfive_altitude-img__nwsrg {
    width: 50px;
    height: 50px;
  }
  .Awfive_speed-img__Uyirm {
    width: 50px;
    height: 50px;
  }
  .Awfive_payload-img__BkJIx {
    width: 50px;
    height: 50px;
  }
  .Awfive_lunch-img__hD2bS {
    width: 50px;
    height: 50px;
  }
  .Awfive_landing-img__u1RlJ {
    width: 50px;
    height: 50px;
  }
}
@media screen and (max-width: 530px) {
  .Awfive_paragraph-big__GAzdx p {
    font-size: 12px;
  }
  .Awfive_paragraph-small-container__DaRQl {
    margin-top: 160px;
  }
  .Awfive_paragraph-big__GAzdx {
    height: 500px;
  }
}
@media screen and (min-width: 1025px) {
  .Awfive_aw-section-one__vLn7P h3 {
    font-size: 68px;
    margin-top: 600px;
  }
}
.Awfive_sections-child__NRSYq:hover,
.Awfive_sections-child__NRSYq:focus,
.Awfive_sections-child__NRSYq:active {
  cursor: pointer;
  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);
  transform: scale(1.2);
}
.Awfive_sections-child__NRSYq:hover .Awfive_h__f2YPU,
.Awfive_sections-child__NRSYq:focus .Awfive_h__f2YPU,
.Awfive_sections-child__NRSYq:active .Awfive_h__f2YPU {
  font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/AW5/Awfive.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,kHAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AAEF;;AAEA,uCAAA;AACA;EACE,aAAA;EACA,8BAAA;EAEA,YAAA;EACA,WAAA;EACA,kBAAA;AAAF;;AAGA,qBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;AAAF;;AAGA,mBAAA;AAEA;EACE,aAAA;EACA,aAAA;EACA,wDAAA;EACA,wBAAA;EACA,4BAAA;AADF;;AAKA;EACE,WAAA;EACA,iBAAA;EAGA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAJF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,yBAAA;EACA,0CAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AASA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AANF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAPF;;AAUA;EACE,UAAA;AAPF;;AAgBA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAbF;;AAgBA;EACE,UAAA;EAEA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,0CAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAdF;;AAmBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;EACA,gBAAA;AAhBF;;AAoBA;EAEE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;EAIA,kBAAA;EACA,WAAA;AArBF;;AA0BA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;EACA,6BAAA;AAvBF;;AA4BA;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;AAzBF;;AA8BA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,uBAAA;EACA,cAAA;AA3BF;;AA+BA;EACE,UAAA,EAAA,yCAAA;EACA,YAAA,EAAA,4CAAA;EACA,YAAA,EAAA,yBAAA;EACA,sBAAA,EAAA,+BAAA;EACA,gBAAA,EAAA,iCAAA;EACA,cAAA,EAAA,gCAAA;AA5BF;;AAgCA;EAGE;IACE,kBAAA;EA/BF;EAkCA;IACE,eAAA;IACA,mBAAA;EAhCF;EAoCA;IACE,eAAA;IACA,YAAA;IACA,YAAA;EAlCF;AACF;AAsCA;EACE;IACE,sBAAA;IACA,aAAA;EApCF;EAwCA;IACE,gBAAA;IACA,UAAA;EAtCF;EA2CA;IAEE,iBAAA;EA1CF;EA6CA;IACE,YAAA;IACA,aAAA;EA3CF;EA8CA;IACE,WAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EA5CF;EA+CD;IACE,aAAA;EA7CD;EA+CA;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,iCAAA;EA7CF;EA+CF;IACE,eAAA;EA7CA;EAkDA;IACE,eAAA;EAhDF;EAoDA;IAEE,iBAAA;EAnDF;EAwDA;IACE,aAAA;EAtDF;EAgEA;IACE,YAAA;IACA,mBAAA;EA9DF;EAkEA;IACF,kBAAA;IACI,aAAA;EAhEF;EAmEA;IACE,gBAAA;EAjEF;EAoEA;IAEE,YAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,iBAAA;EAnEF;EAsEA;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EApEF;AACF;AAuEA;EAEE;IACE,YAAA;IACA,aAAA;EAtEF;EAyEA;IACE,eAAA;IACA,iBAAA;EAvEF;EA0EA;IACE,eAAA;EAxEF;EA2EA;IACE,iBAAA;EAzEF;EAgFA;IAEE,iBAAA;IACA,eAAA;EA/EF;EAiFA;IACE,YAAA;EA/EF;EAkFA;IACE,eAAA;EAhFF;EAmFA;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAjFF;EAsFA;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EApFF;EAwFF;IACE,YAAA;IACA,aAAA;EAtFA;EAwFA;IACE,WAAA;IACA,YAAA;EAtFF;EA0FA;IACE,WAAA;IACA,YAAA;EAxFF;EA2FA;IACE,WAAA;IACA,YAAA;EAzFF;EA4FA;IACE,WAAA;IACA,YAAA;EA1FF;EA6FA;IACE,WAAA;IACA,YAAA;EA3FF;EA8FA;IACE,WAAA;IACA,YAAA;EA5FF;EA8FA;IACE,WAAA;IACA,YAAA;EA5FF;EA8FA;IACE,WAAA;IACA,YAAA;EA5FF;AACF;AAiGA;EACE;IACE,eAAA;EA/FF;EAkGA;IACE,iBAAA;EAhGF;EAmGA;IACE,aAAA;EAjGF;AACF;AAsGA;EACE;IAEE,eAAA;IACA,iBAAA;EArGF;AACF;AA8GA;;;EAGE,eAAA;EACA,mDAAA;EACA,qBAAA;AA5GF;AA8GE;;;EACE,eAAA;AA1GJ","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.aw-container {\n  width: 100%;\n  height: 100vh;\n  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(\"https://i.imgur.com/Ye0U6ix.jpeg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: relative;\n\n}\n\n/* Գլխավոր դիվը էկրանով ամբողջությամբ */\n.aw-section-one {\n  display: flex;\n  justify-content: space-between;\n  //align-items: flex-end;\n  height: 100%;\n  width: 100%;\n  padding: 40px 60px;\n}\n\n/* Ձախ ներքևի տեքստ */\n.aw-container h3 {\n  font-size: 80px;\n  font-weight: 700;\n  font-family: 'Roboto', sans-serif;\n  color: #FFFFFF80;\n  opacity: 0.5;\n  margin-top: 550px;\n}\n\n/* Աջ կողմի նկարը */\n\n.aw-image {\n  width: 1800px;\n  height: 750px;\n  background-image: url(\"https://i.imgur.com/UikQhYH.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  //background-position: center;\n}\n\n.sections {\n  width: 100%;\n  max-width: 1500px;\n  //height: 70vh;\n  //background-color: red;\n  margin: auto;\n  margin-top: -180px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.sections-child {\n  width: 324px;\n  height: 225px;\n  background-color: white;\n  box-shadow: 1px 1px 1px;\n  //display: flex;\n  border-bottom: 1px solid;\n  border-right: 1px solid;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 40px;\n  transform: perspective(1px) translateZ(0);\n  box-shadow: 2px 2px 2px transparent;\n  transition-duration: 0.3s;\n  transition-property: box-shadow, transform;\n}\n\n.child-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/range.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.sections-child h2 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 100%;\n  color: #4C6D59;\n  text-align: center;\n}\n\n.sections-child p {\n  color: #4C6D59;\n  font-weight: 500;\n  font-size: 25.5px;\n  line-height: 100%;\n}\n\n.weight-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/weight.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n\n}\n\n.time-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/time.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n\n.altitude-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/altitude.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.speed-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/speed.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.payload-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/payload.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.lunch-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/lunch.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.landing-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/landing.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.p-Container {\n  width: 80%;\n  //display: flex;\n\n  //justify-content: center;\n  //align-items: center;\n  //text-align: center;\n\n}\n\n.p-Container p{\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.paragraph-section {\n  width: 80%;\n  //height: 70vh;\n  background-color: #4C6D59;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  margin-top: 100px;\n  margin-bottom: 150px;\n}\n\n.paragraph-big {\n  width: 100%;\n  margin: auto;\n  padding: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  background-color: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 48px;\n  position: relative;\n  margin-top: 100px;\n  margin-bottom: 100px;\n  text-align: center;\n\n\n}\n\n.paragraph-big p {\n  color: white;\n  font-size: 32px;\n  font-weight: 500;\n  font-family: 'Roboto', sans-serif;\n  width: 65%;\n  line-height: 1.4;\n\n}\n\n.paragraph-small-container {\n  //width: 30%;\n  display: flex;\n  height: 60%;\n  margin-top: 200px;\n  flex-direction: column;\n  justify-content: space-between;\n  //align-items: flex-end;\n  //background-color: red;\n  //position: absolute;\n  margin-left: -70px;\n  z-index: 99;\n\n\n}\n\n.paragraph-small {\n  width: 149px;\n  height: 94px;\n  border: 2px solid white;\n  border-radius: 19px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  font-family: 'Roboto', sans-serif;\n  background-color: transparent;\n\n}\n\n\n.product-section {\n  width: 80%;\n  height: 113px;\n  display: flex;\n  margin: auto;\n  background-color: #252626;\n  margin-bottom: 100px;\n  justify-content: space-around;\n  align-items: center;\n\n\n}\n\n.product-section span {\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.product-section button {\n  width: 300px;\n  height: 66px;\n  border-radius: 32px;\n  border: solid white;\n  background-color: #252626;\n  color: white;\n  font-size: 32px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.product-section button:hover {\n  background-color: white;\n  color: #191A1A;\n}\n\n\n.threejs-figure {\n  width: 80%; /* Adjust to 80% of the container width */\n  height: 50vh; /* Adjust height to 50% of viewport height */\n  margin: auto; /* Center the container */\n  background-color: #333; /* Dark gray background color */\n  overflow: hidden; /* Prevent horizontal scrolling */\n  display: block; /* Ensure it's a block element */\n}\n\n\n@media (max-width: 1000px) {\n\n\n  .product-section{\n    margin-top: -340px;\n  }\n\n  .product-section span {\n    font-size: 16px;\n    margin-bottom: 20px;\n\n  }\n\n  .product-section button {\n    font-size: 16px;\n    height: 32px;\n    width:100px;\n\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .paragraph-big {\n    flex-direction: column;\n    padding: 30px;\n    //height: 50vh;\n\n  }\n  .paragraph-section {\n    max-width: 500px;\n    width: 80%;\n\n    //margin: auto;\n    //background-color: red;\n  }\n  .paragraph-big {\n    //background-color: red;\n    margin-left: -2px;\n  }\n\n  .sections-child {\n    width: 280px;\n    height: 250px;\n  }\n\n  .paragraph-big p {\n    width: 100%;\n    font-size: 24px;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n .paragraph-section{\n   height: 500px;\n }\n  .p-Container p{\n    color: white;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 100%;\n    font-family: 'Roboto', sans-serif;\n  }\n.p-Container h2{\n  font-size: 20px;\n}\n\n\n\n  .p-Container p{\n    font-size: 14px;\n  }\n\n\n  .aw-section-one h3 {\n    //background-color: red;\n    margin-top: 360px;\n    //font-size: 19px;\n\n  }\n\n  .aw-container {\n    height: 800px;\n  }\n\n  //.paragraph-small-container {\n  //  margin: 0 auto;\n  //  flex-direction: row;\n  //  justify-content: center;\n  //  gap: 20px;\n  //  height: auto;\n  //}\n  .sections-child {\n    margin: auto;\n    margin-bottom: 25px;\n  }\n\n\n  .product-section {\nmargin-top: -500px;\n    height: 100px;\n  }\n\n  .product-section span{\n    margin-top: 22px;\n  }\n\n  .aw-image {\n    //margin: auto;\n    width: 400px;\n    height: 200px;\n    background-size: cover;\n    margin-left: -110px;\n    margin-top: -40px;\n\n  }\n  .paragraph-small {\n    width: 130px;\n    height: 70px;\n    font-size: 14px;\n    margin-left: 30px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .sections-child{\n    width: 150px;\n    height: 150px;\n  }\n\n  .sections-child h2{\n    font-size: 17px;\n    margin-top: 2.5px;\n  }\n\n  .sections-child p{\n    font-size: 14px;\n  }\n\n  .paragraph-section {\n    margin-top: 200px;\n\n  }\n\n\n\n\n  .aw-section-one h3 {\n    //background-color: red;\n    margin-top: 180px;\n    font-size: 19px;\n  }\n  .aw-container {\n    height: 60vh;\n  }\n\n  .paragraph-big p {\n    font-size: 16px;\n  }\n\n  .paragraph-small {\n    width: 110px;\n    height: 60px;\n    font-size: 12px;\n    margin-left: 30px;\n\n\n  }\n\n  .paragraph-small-container {\n    flex-direction: column;\n    gap: 16px;\n    height: 300px;\n  }\n\n\n.sections-child{\n  width: 145px;\n  height: 140px;\n}\n  .child-img{\n    width: 50px;\n    height: 50px;\n\n  }\n\n  .weight-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .time-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .altitude-img{\n    width: 50px;\n    height: 50px;\n\n  }\n  .speed-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .payload-img{\n    width: 50px;\n    height: 50px;\n  }\n  .lunch-img{\n    width: 50px;\n    height: 50px;\n  }\n  .landing-img{\n    width: 50px;\n    height: 50px;\n  }\n\n}\n\n\n@media screen and (max-width: 530px) {\n  .paragraph-big p {\n    font-size: 12px;\n  }\n\n  .paragraph-small-container {\n    margin-top: 160px;\n    //margin-left: 2px;\n  }\n  .paragraph-big {\n    height: 500px;\n  }\n\n}\n\n\n@media screen and (min-width: 1025px) {\n  .aw-section-one h3 {\n    //background-color: red;\n    font-size: 68px;\n    margin-top: 600px;\n  }\n  //.aw-container{\n  //  height: 50vh;\n  //}\n\n\n}\n\n\n.sections-child:hover,\n.sections-child:focus,\n.sections-child:active {\n  cursor: pointer;\n  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);\n  transform: scale(1.2);\n\n  .h{\n    font-size: 22px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aw-container": `Awfive_aw-container__abUdh`,
	"aw-section-one": `Awfive_aw-section-one__vLn7P`,
	"aw-image": `Awfive_aw-image__rBQH6`,
	"sections": `Awfive_sections__Qv2X7`,
	"sections-child": `Awfive_sections-child__NRSYq`,
	"child-img": `Awfive_child-img__c7yna`,
	"weight-img": `Awfive_weight-img__wNwsw`,
	"time-img": `Awfive_time-img__VkUnM`,
	"altitude-img": `Awfive_altitude-img__nwsrg`,
	"speed-img": `Awfive_speed-img__Uyirm`,
	"payload-img": `Awfive_payload-img__BkJIx`,
	"lunch-img": `Awfive_lunch-img__hD2bS`,
	"landing-img": `Awfive_landing-img__u1RlJ`,
	"p-Container": `Awfive_p-Container__wYw8r`,
	"paragraph-section": `Awfive_paragraph-section__zI3e7`,
	"paragraph-big": `Awfive_paragraph-big__GAzdx`,
	"paragraph-small-container": `Awfive_paragraph-small-container__DaRQl`,
	"paragraph-small": `Awfive_paragraph-small__1AM2K`,
	"product-section": `Awfive_product-section__2CvqI`,
	"threejs-figure": `Awfive_threejs-figure__FDFkq`,
	"h": `Awfive_h__f2YPU`
};
export default ___CSS_LOADER_EXPORT___;
